import { isNotNil, sortBy } from 'es-toolkit'
import { useMemo } from 'react'
import { useAssetLocations } from '../../data/locations.tsx'

export const useReportLocations = () => {
	const { data: locations, isPending } = useAssetLocations()

	return useMemo(() => {
		const locationsByVrn = new Map((locations ?? []).map((location) => [location.assetVrn, location]))

		return {
			locationsOf: (assetVrns: readonly string[]) => sortBy(assetVrns.map((vrn) => locationsByVrn.get(vrn)).filter(isNotNil), ['name']),
			isPending,
		}
	}, [locations, isPending])
}
